export default "__VITE_ASSET__BkPFKQfb__";